import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectIsLoadingCreate } from "../store/authentication/authSlice";

export const useLoadingModal = () => {
  const isLoadingCreate = useSelector(selectIsLoadingCreate);

  return useMemo(() => isLoadingCreate, [isLoadingCreate]);
};
